import React from 'react';

import DashboardCards from '../AdminDashboards/DashboardCards';
import {
  DEVELOPMENT_DASHBOARD_PATH,
  toolsWithBasePath
} from '../AdminDashboards/adminTools';

// Purchases overview and User cost are listed on the community admin
// dashboard, not here
const developmentTools = [
  {
    key: 'survey-visibility',
    title: 'Survey Visibility Checker',
    description: 'Check which surveys are visible for a specific user and why.',
    path: '/survey-visibility'
  },
  {
    key: 'survey-completion-test',
    title: 'Survey completion test',
    description:
      'Automatically complete a survey with random answers, N times, as a given user.',
    path: '/survey-completion-test'
  },
  {
    key: 'result-answers-visualiser',
    title: 'Result answers visualiser',
    description:
      'Visualise the survey structure, the answers given, and the path taken for a result id.',
    path: '/result-answers-visualiser'
  },
  {
    key: 'survey-graph-paths',
    title: 'Survey graph paths',
    description:
      'Draw a survey as a graph, with every question connected by the paths the flow can take.',
    path: '/survey-graph-paths'
  }
];

export default function() {
  return (
    <DashboardCards
      title="Development Dashboard"
      intro="Welcome, Dev Admin! Select a tool to get started."
      cards={toolsWithBasePath(developmentTools, DEVELOPMENT_DASHBOARD_PATH)}
    />
  );
}
